module.exports = __webpack_public_path__ + "img/scene5.9030d852.gif";